import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import CustomButton from "../../components/Form/ArrowButton";
import LoginInput from "../../components/Form/LoginInput";
import ButtonSpinner from "../../components/loading/ButtonSpinner";
import edit from "../../assets/Icons/fluent_edit.svg";
import avatar from "../../assets/Icons/user-avatar.png";
import { useThunk } from "../../hooks/useThunk";
import showToast from "../../utils/toastNotifications";
import useForm from "../../hooks/useForm";
import { USER_INPUT_FIELD_TYPES } from "../../constants/userInputFieldNames";
import useFirebaseFileUpload from "../../hooks/useFirebaseFileUpload";
import { useSelector } from "react-redux";
import { updateUserProfile } from "../../store";
import { errorMessages } from "../../constants/frontendErrorMessages";
import { ClipLoader } from "react-spinners";

const Profile = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.auth.user);
  const currentProfilePicture = userData.profilePicture;

  console.log("current: ", currentProfilePicture);

  const [uploadedImage, setUploadedImage] = useState(null); // State for uploaded image
  console.log(uploadedImage);
  const [isMissingOrMalformed, setIsMissingOrMalformed] = useState(false);

  const fileInputRef = useRef(null); // Ref for the hidden file input

  // defining thunks
  const [doUpdateUserProfile, isUpdatingUserProfile, userProfileUpdatingError] =
    useThunk(updateUserProfile);
  const [doUploadImage, isUploadingImage] = useFirebaseFileUpload();

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    setFormData,
  } = useForm(
    {
      firstName: userData?.firstName,
      lastName: userData?.lastName,
      phoneNumber: userData.phoneNumber,
    },
    {
      firstName: true,
      lastName: true,
      phoneNumber: false,
    },
    {
      firstName: USER_INPUT_FIELD_TYPES.FIRST_NAME,
      lastName: USER_INPUT_FIELD_TYPES.LAST_NAME,
      phoneNumber: USER_INPUT_FIELD_TYPES.PHONE,
    }
  );

  // Trigger click on the hidden file input
  const handleEditImageClick = () => {
    fileInputRef.current.click();
  };

  // sync uploading images with state
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
    }
  };

  // cancel the operation, clear data and back
  const handleCancelClick = () => {
    setFormData({
      firstName: "",
      lastName: "",
      phoneNumber: "",
    });
    setUploadedImage(null);
    setIsMissingOrMalformed(false);
    navigate(-1);
  };

  // handle the save button
  const handleSaveClick = async () => {
    if (validateForm()) {
      if (
        !uploadedImage &&
        formData.firstName === userData?.firstName &&
        formData.lastName === userData?.lastName &&
        formData.phoneNumber === userData?.phoneNumber
      ) {
        showToast("info", "You haven't made any changes.");
        return;
      }

      let updatedFormData = { ...formData };

      if (uploadedImage) {
        const uploadResult = await doUploadImage(
          [uploadedImage],
          "user/profilePicture"
        );
        if (!uploadResult.success) {
          showToast("error", uploadResult?.error?.message || "Failed to upload files");
          return;
        }
        updatedFormData.profilePicture = uploadResult?.uploadedUrls[0];
        console.log(uploadResult?.uploadedUrls[0]);
      }

      const result = await doUpdateUserProfile(updatedFormData);

      if (result.success) {
        showToast("success", result.response?.message);
        handleCancelClick();
      } else {
        showToast("error", result.error?.message);
      }
    } else {
      showToast("error", "Please Provide Required and Valid Information");
    }
  };

  return (
    <div
      className={`min-[80%] px-4 xl:px-8 mt-24  flex flex-col w-full xl:w-[calc(100vw-256px)]`}
    >
      {" "}
      <h1 className="text-primary xl:hidden font-roboto font-semibold text-[24px] leading-5 mb-6 py-2">
        Edit Profile
      </h1>
      <div className="overflow-y-auto">
        <div className="bg-white mb-[24px] mr-4 rounded-lg py- md:py- max-w-full md:max-w-[2200px] w-auto mx-auto">
          <div className="flex flex-col">
            <div className="mb-6">
              <span className="font-inter leading-6 text-level-3 font-medium text-secondary">
                Profile Picture
              </span>
              {/* <span className="text-light-red font-medium text-level-3 leading-6">
                {" "}
                *
              </span> */}
              {uploadedImage ? (
                <div className="relative">
                  <div
                    className="rounded-full w-8 h-8 bg-primary absolute left-[102px] top-[97px] items-center justify-center"
                    onClick={handleEditImageClick}
                  >
                    <img
                      src={edit}
                      alt="imgEdit"
                      className="items-center justify-center p-[6px] cursor-pointer"
                    />
                  </div>
                  <img
                    src={URL.createObjectURL(uploadedImage)}
                    alt="Uploaded"
                    className="w-[120px] h-[120px] object-cover rounded-[5px] mt-3 border border-secondary"
                  />
                </div>
              ) : (
                <div>
                  <div className="relative flex items-center justify-center border border-secondary w-[120px] h-[120px] rounded-[5px] mt-3">
                    <img
                      src={
                        currentProfilePicture ? currentProfilePicture : avatar
                      }
                      alt="Profile Picture"
                      onError={() => {
                        setIsMissingOrMalformed(true);
                      }}
                      onClick={handleEditImageClick}
                      className=" cursor-pointer p-[6px] rounded-[5px] w-[120px] h-[120px] items-center justify-center object-cover"
                    />
                    <img
                      src={edit}
                      alt="imgEdit"
                      onClick={handleEditImageClick}
                      className=" cursor-pointer p-[6px] rounded-full w-auto h-8 bg-primary absolute -bottom-2 -right-2 items-center justify-center"
                    />
                  </div>
                </div>
              )}
              {/* Hidden File Input */}
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                className="hidden"
                onChange={handleImageChange}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-x-6 gap-y-6 mt- w-full px-0">
              {/* First Row: Two Input Fields */}
              <div>
                <LoginInput
                  className=" w-full 2xl:w-full px-4 "
                  id="firstName"
                  name="firstName"
                  label="First Name"
                  type="text"
                  value={formData.firstName}
                  placeholder="First Name"
                  error={touched.firstName && errors.firstName}
                  onChange={(e) =>
                    handleInputChange("firstName", e.target.value)
                  }
                  onBlur={() => handleBlur("firstName", formData.firstName)}
                  isRequired={true}
                  isFloatingLabel={false}
                />
              </div>
              <div>
                <LoginInput
                  className=" w-full 2xl:w-full px-4 "
                  id="lastName"
                  name="lastName"
                  label="Last Name"
                  type="text"
                  value={formData.lastName}
                  placeholder="Last Name"
                  error={touched.lastName && errors.lastName}
                  onChange={(e) =>
                    handleInputChange("lastName", e.target.value)
                  }
                  onBlur={() => handleBlur("lastName", formData.lastName)}
                  isRequired={true}
                  isFloatingLabel={false}
                />
              </div>

              {/* Second Row: Two Input Fields */}
              <div>
                <LoginInput
                  className=" w-full 2xl:w-full px-4 "
                  id="phoneNumber"
                  name="phoneNumber"
                  label="Phone Number"
                  type="text"
                  value={formData.phoneNumber}
                  placeholder="Contact Number"
                  error={touched.phoneNumber && errors.phoneNumber}
                  onChange={(e) =>
                    handleInputChange("phoneNumber", e.target.value)
                  }
                  onBlur={() => handleBlur("phoneNumber", formData.phoneNumber)}
                  isRequired={false}
                  isFloatingLabel={false}
                />
              </div>
              <div>
                <LoginInput
                  className="w-full 2xl:w-full px-4"
                  inputStyle={"bg-neutral-200"}
                  id="email"
                  name="email"
                  label="Email"
                  type="text"
                  value={userData.email}
                  disabled={true}
                  // readOnly={true}
                  isFloatingLabel={false}
                />
              </div>
            </div>

            <div className="flex justify-between mt-[93px] w-full">
              <CustomButton
                text="Cancel"
                onClick={handleCancelClick}
                width="120px"
                height="44px"
                iconDirection=""
                iconPosition=""
              />

              <CustomButton
                text={
                  isUploadingImage || isUpdatingUserProfile ? (
                    <ClipLoader
                      loading={isUpdatingUserProfile || isUploadingImage}
                      speedMultiplier={1}
                      size={22}
                      color="#60a5fa"
                    />
                  ) : (
                    "Save"
                  )
                }
                type="button"
                iconDirection=""
                iconPosition=""
                onClick={handleSaveClick}
                width="120px"
                height="44px"
                disabled={isUploadingImage || isUpdatingUserProfile}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
